<section class="signup-steps-section">
    <div class="signup-steps-container">
        <h2 class="signup-steps-title">How to sign up</h2>

        <div class="signup-steps-main">
            <div class="signup-steps-grid">
                <article class="signup-step-card" *ngFor="let step of steps">
                    <div class="step-icon-wrap">
                        <img [src]="step.icon" [alt]="step.title">
                    </div>
                    <h3>{{ step.title }}</h3>
                    <p>{{ step.description }}</p>
                </article>

                <article class="signup-step-card active-step">
                    <div class="step-icon-wrap">
                        <img src="assets/img/svg/gamepad.svg" alt="Start Playing">
                    </div>
                    <h3>Start Playing</h3>
                    <p>Once you're in, you can play, check leaderboards, and claim rewards.</p>
                    <button class="signin-now-btn">SIGN IN NOW</button>
                </article>
            </div>

            <div class="phone-visual">
                <div class="phone-orb"></div>
                <img src="assets/img/svg/yogamez@2x.png" alt="YoGamez mobile app" class="phone-image" loading="lazy">
            </div>
        </div>

        <div class="pro-tip-row">
            <span class="pro-tip-chip">Pro Tip:</span>
            <p>Stay signed in for instant access to games, challenges, and exclusive rewards every time you visit.</p>
        </div>
    </div>
</section>
